<template>
  <div class="inventory inventory-container">
    <WineDetailOverlay ref="wineDetailOverlay" v-model="selectedWine" :detailsClass="detailsClass"
      :closePressed="closeWineDetails" :inventoryMode="true" />
    <div style="display:flex; overflow: hidden; flex-direction: column;flex: 1;">
      <b-table class="inventory-wines-table" v-model="currentItems"
        select-mode="single" id="wines" selectable ref="wines" :items="filteredWines" :fields="fields" sticky-header
        @row-selected="(item) => showInventorySidepanel(item)" @context-changed="handleRefreshed"
        :sort-compare="mySortCompare" :per-page="perPage" :current-page="currentPage">
        <template #cell(venueWine)="data">
          <b-row>
            {{ data.value.wine.winery.title }}
          </b-row>
          <b-row class="font-16 color-white">
            {{ data.value.title }}
          </b-row>
        </template>
        <template #cell(bottleSize)="data">
          <b-row>
            {{ getBottleSizeAmount(data.value) }} l
          </b-row>
        </template>
        <template #cell(venueWine.wine.wineType)="data">
          <b-row>
            {{ $t('wineTypes.' + data.value.localeKey) }} 
          </b-row>
        </template>
        <template class="inventoryVenueWineState" #cell(venueWine.inventoryVenueWineState)="data">
          <div v-if="getInventoryState(data.item) === 'valid'">
            <CheckedIcon />
          </div>
          <div v-if="getInventoryState(data.item) === 'divergent'">
            <DivergentIcon />
          </div>
          <div v-if="getInventoryState(data.item) === 'invalid'">
            <IncompleteIcon />
          </div>
          <div v-if="getInventoryState(data.item) === 'duplicate'">
            <DuplicateIconChecked />
          </div>

        </template>
        <!--
        <template #table-colgroup="scope">
          <col v-for="field in scope.fields"
              :key="field.key"
              :style="{ width: field.key === 'venueWine.bottleSize' ? '30px' : '180px' }"
            >
        </template>
        -->
      </b-table>

      <b-pagination class="pagination" @change="paginationClick" v-model="currentPage" :total-rows="wines.length" :per-page="perPage"
      aria-controls="my-table" hide-ellipsis prev-text="" next-text="" first-text="" last-text="" limit="4" align="center"></b-pagination>
    </div>
   
      <InventorySidepanel :tableLength="currentItems.length" :selectedRowIndex="selectedRowIndex"
        :showSidepanel="showSidepanel" @previousRow="previousRow" @nextRow="nextRow"
        :selectedInventoryVenueWine="selectedInventoryVenueWine" :inventoryWines="wines" ref="sidepanel" :currentPage="currentPage" @updateFromSidePanel="updateWineTable" />
  </div>

</template>

<script>
import InventorySidepanel from './InventorySidepanel.vue';
import CheckedIcon from '../icons/CheckedIcon.vue';
import WineDetailOverlay from '../WineDetailOverlay.vue';
import { mapGetters } from 'vuex';
import DuplicateIconChecked from '../icons/DuplicateIconChecked.vue';
import DataService from '@/services/StrapiService.js';
import DivergentIcon from '../icons/DivergentIcon.vue';
import IncompleteIcon from '../icons/IncompleteIcon.vue';
import Constants from '@/utils/constants.js';
import { getVenueCurrency } from '@/utils/functions';
import Tracking from '@/utils/tracking'

export default {
  name: 'InventoryContent',
  components: {
    InventorySidepanel,
    CheckedIcon,
    WineDetailOverlay,
    DuplicateIconChecked,
    DivergentIcon,
    IncompleteIcon
  },
  data() {
    return {
      selectedInventoryVenueWine: null,
      showSidepanel: false,
      searchFilter: '',
      currentItems: [],
      selectedWine: {},
      detailsClass: '',
      selectedRowIndex: null,
      currentPage: 1,
      perPage: 200,
      selectRowAfterRefresh: false,
      clickFromPreviousRow: false
    }
  },
  props: {
    wines: {
      type: Array,
    },
    inventoryState: {
      type: String,
    }
  },
  watch: {
    selectedRowIndex(rowIndex) {
      this.$emit('changedRowIndex', rowIndex)
    },

  },
  methods: {
    amountRows() {
      return this.wines.length
    },
    getBottleSizeAmount(bottleSize) {
      if (!bottleSize) return 0;
      if (bottleSize.attributes && bottleSize.attributes.amount) {
        return bottleSize.attributes.amount;
      }
      if (bottleSize.amount) {
        return bottleSize.amount;
      }
      return 0;
    },
    scrollToRow(index) {
      const table = this.$refs.wines.$el.getBoundingClientRect();
      const top = table.top
      const bottom = table.bottom
      const tbody = this.$refs.wines.$el.querySelector('tbody');
      const row = tbody.querySelectorAll('tr')[index];
      const rowRect = row.getBoundingClientRect();
      if (row) {
        const isInViewport = (
          rowRect.top >= top &&
          rowRect.bottom <= bottom
        );
        if (!isInViewport) {
          row.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    },
    getInventoryState(item) {
      if (item.actualAmountFloat == item.targetAmountFloat && (item.inventoryVenueWineState === Constants.inventory.CHECKED || item.inventoryVenueWineState === Constants.inventory.TRANSFERRED) && item.purchasePrice !== null && item.purchasePrice !== 0) {
        return 'valid'
      } else if (item.duplicate === true) {
        return 'duplicate'
      } else if (item.inventoryVenueWineState == Constants.inventory.NONE) {
        return 'unchecked'
      } else if (item.inventoryVenueWineState == Constants.inventory.CHECKED && item.actualAmountFloat !== item.targetAmountFloat) {
        return 'divergent'
      } else {
        return 'invalid'
      }
    },
    openSidepanelFromButton() {
      const index = this.currentItems.findIndex(inventory => {
        return inventory.inventoryVenueWineState == Constants.inventory.NONE
      });
      if (index === -1) {
        // open first Element in List
        this.selectedRowIndex = 0
        this.selectedInventoryVenueWine = this.currentItems[0];
      } else {
        // open first unchecked Wine
        this.selectedRowIndex = index
        this.selectedInventoryVenueWine = this.currentItems[index];
      }
      this.$emit('buttonTextInventoryOff')
      this.$refs.wines.selectRow(this.selectedRowIndex)
      this.scrollToRow(this.selectedRowIndex)
    },
    showInventorySidepanel(item) {
      if (this.inventoryState === 'finished') {
        return
      }
      if (item.length === 0 && this.clickFromPreviousRow) {
        this.showSidepanel = true
        this.$emit('buttonTextInventoryOff')
        this.selectedInventoryVenueWine = this.currentItems[this.selectedRowIndex];
        this.clickFromPreviousRow = false
        return;
      }
      if (item.length === 0) { /* click on already selected row */
         this.closeSelectedRow()
         return;
      }
      if (this.selectedInventoryVenueWine) {
        // save changes of previous selected row when new row is selected
        if (this.selectedInventoryVenueWine.actualAmountFloat !== null) {
          this.selectedInventoryVenueWine.inventoryVenueWineState = Constants.inventory.CHECKED
          this.saveInventoryVenueWine(this.selectedInventoryVenueWine.id, this.selectedInventoryVenueWine)
          this.$emit('updateInventoryWineTable', this.selectedInventoryVenueWine)
        }
      }
      
      const index = this.currentItems.findIndex(inventory => inventory.id === item[0].id);
      if (this.selectedRowIndex === index) {
        this.selectedRowIndex = null
      }
      this.selectedRowIndex = index
      this.selectedInventoryVenueWine = this.currentItems[index];
      if (!this.isInventoryOnly) {
        this.showRegularSidepanel(item)
        return
      }
      this.$nextTick(() => {
        this.showSidepanel = true;
      })
      this.$emit('buttonTextInventoryOff')
    },
    closeSelectedRow() {
      this.selectedRowIndex = null
      this.showSidepanel = false;
      this.$emit('buttonTextInventoryOn')
    },
    closeSidepanel() {
      this.showSidepanel = false;
      this.selectedInventoryVenueWine = null;
      this.selectedRowIndex = null
      this.$refs.wines.clearSelected()
      this.$emit('buttonTextInventoryOn')
    },
    showRegularSidepanel(item) {
      const index = this.filteredWines.findIndex(inventory => inventory.id === item[0].id);
      this.selectedRowIndex = index
      this.selectedInventoryVenueWine = this.filteredWines[index];
      this.showWineDetails(this.selectedInventoryVenueWine.venueWine)
    },
    showWineDetails(venuewine) {
      this.selectedWine = this.mapVenueWineForSidepanel(venuewine)
      this.detailsClass = "active"
    },
    mapVenueWineForSidepanel(venuewine) {
      /* can be ditched when WineDetailOverlay is updated with the mapped API Data */
      const venueWineForSidepanel = {
        id: venuewine.id,
        attributes: {
          ...venuewine,
          wine: {
            data: {
              id: venuewine.wine.id,
              attributes: {
                ...venuewine.wine,
                land: {
                  data: {
                    attributes: {
                      ...venuewine.wine.land
                    },
                    id: venuewine.wine.land.id
                  }
                },
                region: {
                  data: {
                    attributes: {
                      ...venuewine.wine.region
                    },
                    id: venuewine.wine.region.id
                  }
                },
                grapeVariety: {
                  data: {
                    attributes: {
                      ...venuewine.wine.grapeVariety
                    },
                    id: venuewine.wine.grapeVariety.id
                  }
                },
                wineType: {
                  data: {
                    attributes: {
                      ...venuewine.wine.wineType
                    },
                    id: venuewine.wine.wineType.id
                  }
                },
                winery: {
                  data: {
                    attributes: {
                      ...venuewine.wine.winery
                    },
                    id: venuewine.wine.winery.id
                  }
                }
              }
            }
          },
          wineId: venuewine.wine.id,
        }
      }
      return venueWineForSidepanel
    },
    closeWineDetails() {
      this.detailsClass = ""
      this.selectedWine = {}
    },
    paginationClick() {
      // if sidepanel is open, stay open:
      if (this.showSidepanel) {
        this.selectRowAfterRefresh = true
      }
     
    },
    updateWineTable(wine) {
      this.$emit('updateInventoryWineTable', wine)
    },
    nextRow(inventoryVenueWine, newIndex) {
      if (this.inventoryState === 'uploaded') {
        this.$emit('changeStateBackToOpen')
      }
      this.$emit('updateInventoryWineTable', inventoryVenueWine, this.selectedRowIndex)
      if (newIndex !== undefined) {
        this.selectedRowIndex = newIndex;
        if (this.currentPage < this.wines.length / this.perPage) {
          this.currentPage += 1
        } else {
          this.currentPage = 1
        }
        this.$refs.wines.selectRow(this.selectedRowIndex)
        this.scrollToRow(this.selectedRowIndex)
      } else {
        this.selectedRowIndex++;
        this.$refs.wines.selectRow(this.selectedRowIndex)
        this.scrollToRow(this.selectedRowIndex)
      }
    },
    handleRefreshed() {
      if (this.selectRowAfterRefresh == true) {
        this.selectRowAfterRefresh = false
        this.$nextTick(() => {
          this.$refs.wines.selectRow(0)
          this.scrollToRow(0)
        })
      }
    },
    previousRow() {
      if (this.currentPage < this.wines.length / this.perPage && this.currentPage > 1 && this.selectedRowIndex === 0) {
        this.currentPage -= 1
        this.clickFromPreviousRow = true
        this.selectedRowIndex = this.perPage - 1
        this.$nextTick(() => {
          this.$refs.wines.selectRow(this.selectedRowIndex)
          this.scrollToRow(this.selectedRowIndex)


        })
      } else {
        this.selectedRowIndex--;
        this.$refs.wines.selectRow(this.selectedRowIndex)
        this.scrollToRow(this.selectedRowIndex)
      }

    },
    searchWines(wine) {
      if (!this.searchFilter) {
        return true;
      }
      const searchLower = this.searchFilter.toLowerCase();
      return (
        wine.venueWine.wine.winery.title?.toLowerCase().includes(searchLower) ||
        wine.venueWine.title?.toLowerCase().includes(searchLower) ||
        (wine.shelf?.toLowerCase().includes(searchLower)) ||
        wine.bottleSize.amount?.toString().includes(this.searchFilter) ||
        wine.year?.toString().includes(this.searchFilter) ||
        wine.venueWine.wine.wineType.title?.toLowerCase().includes(searchLower) ||
        wine.venueWine.wine.land.title?.toLowerCase().includes(searchLower) ||
        wine.venueWine.wine.region.title?.toLowerCase().includes(searchLower) ||
        wine.venueWine.wine.grapeVariety.title?.toLowerCase().includes(searchLower)
      );
    },
    mySortCompare(a, b, key) {
      if (key === 'venueWine') {
        return a[key].wine.winery.title.localeCompare(b[key].wine.winery.title)
      } else {
        // Let b-table handle sorting other fields (other than `venueWine` field)
        return false
      }
    },
    async saveInventoryVenueWine(id, inventoryVenueWine) {

      DataService.updateInventoryVenueWine(id, inventoryVenueWine).then(() => {

        Tracking.trackEvent(
          Tracking.CATEGORY_INVENTORY,
          Tracking.ACTION_UPDATE_INVENTORY_PRODUCT,
          inventoryVenueWine.id
        );

      }).catch((err) => {
        console.log('err :>> ', err);
      })
    },




  },
  mounted() {
    this.$root.$on('changedSearchFilter', (filter) => {
      this.searchFilter = filter
    })
  },

  beforeDestroy() {
  },
  created() {

  },
  computed: {
    filteredWines() {
      return this.wines.filter(wine => this.searchWines(wine));
    },
    getCurrency() {
      return getVenueCurrency(this.getVenue)
    },
    ...mapGetters(['isInventoryOnly', 'getVenue']),
    fields() {
      const fields = [
        {
          key: 'venueWine',
          label: this.$t('general.bottles'),
          sortable: true,
          sortKey: 'value.wine.winery.title'
        },
        {
          key: 'bottleSize',
          label: this.$t('general.size'),
          sortable: true
        },
        {
          key: 'year',
          label: this.$t('general.year'),
          sortable: true
        },
        {
          key: 'purchasePrice',
          label: this.$t('general.ek_short')  + ' ' + this.getCurrency,
          sortable: true
        },
        {
          key: 'shelf',
          label: this.$t('general.shelf'),
          sortable: true
        },
        {
          key: 'venueWine.inventoryVenueWineState',
          label: '',
          sortable: false
        },
      ]
      if (!this.showSidepanel) {
        let insertPosition = fields.length - 2;
        fields.splice(insertPosition, 0,
          {
            key: 'venueWine.wine.wineType',
            label: this.$t('general.color'),
            sortable: true
          },
          {
            key: 'venueWine.wine.grapeVariety.title',
            label: this.$t('general.grapeVariety'),
            sortable: true
          },
        )
      }
      if (!this.isInventoryOnly) {
        let insertPosition = fields.length - 2;
        fields.splice(insertPosition, 0,
          {
            key: 'actualAmountFloat',
            label: this.$t('inventory.actual'),
            sortable: true
          },
          {
            key: 'targetAmountFloat',
            label: this.$t('inventory.target'),
            sortable: true
          }
        );
      }
      return fields
    }
  },

}
</script>

<style>
.inventory table tr.b-table-row-selected.table-active {
  background-color: var(--color-gray-250) !important;
}
</style>